import React, { useState } from "react";
import SETTINGS from "../settings/settings";


const useHttp = () => {
  const [currentProductData, setCurrentProductData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const getDataOfProduct = async(url) => {
    const response = await fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setCurrentProductData(data.data);
        setIsDataLoaded(true);
        return 'success'
      })
      .catch(error=>{
        return 'failure'
      })
    return response
  };
 
  const getShipPrice = (shopId, price, isDrug) =>{
    const url = SETTINGS.shipment + `shop_id=${shopId}&price=${price}&isDrug=${isDrug?1:0}`
    const response = fetch(url)
      .then(res=>res.json())
      .then(data => {
        return data.shipment_cost
      })
      .catch(error=>{
        console.log('api failure')
      })
    return response
  }

  return { getDataOfProduct, isDataLoaded, currentProductData, getShipPrice };
};

export default useHttp;
